import React from 'react';
import { SurveyEmbed } from './components/SurveyEmbed';
import { useNavigate } from 'react-router-dom';
export function App() {
  const navigate = useNavigate();
  return <div className="flex justify-center items-center min-h-screen bg-white relative" data-id="element-0">
      {/* Button in top right corner */}
      <div className="w-full max-w-[1200px] min-h-[250px] overflow-visible shadow-xl" data-id="element-1">
        {/* Full width survey container */}
        <div className="w-full p-0 flex flex-col bg-white overflow-visible" data-id="element-2">
          <div className="flex-1 overflow-visible bg-white" data-id="element-3">
            <SurveyEmbed data-id="element-4" />
          </div>
        </div>
      </div>
    </div>;
}